import React from 'react'
import {useSelector} from "react-redux";
import {useEffect} from "react";
import {addNotification, clearNotifications} from "../../../constants";

const BrowserNotifications = (props) => {
    const {unreviewed_comments_count} = useSelector(state => state.pages.facebook.activePage?.details?.attributes)

    useEffect(() => {
        if (unreviewed_comments_count > 0) {
            addNotification(unreviewed_comments_count)
        } else {
            clearNotifications()
        }
    }, [unreviewed_comments_count])

    return (
        <></>
    )
}

export default React.memo(BrowserNotifications)